import { createTheme } from "@mui/material";

export const defaultTheme = createTheme({
  typography: {
    fontFamily: "Roboto",
    h5: {
      fontSize: "1.25rem",
      lineHeight: "1.5rem",
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 16,
  },
  palette: {
    mode: "light",
    primary: {
      main: "#003781",
    },
    secondary: {
      main: "#DFEFF2",
      dark: "#B5DAE6",
      contrastText: "#FFFFFF",
    },
    info: {
      light: "#EDE7F6",
      main: "#673AB7",
    },
    success: {
      light: "#00C85333",
      main: "#00C853",
    },
    warning: {
      light: "#ffeb3b80",
      main: "#ffeb3b",
    },
  },
});
